export default __webpack_public_path__ + "static/media/esperenza3.fe602dd0.jpg";